





















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { RootGettersReturns } from '../../../store/types';
import { ElementActionsKeys, ElementActionsPayload } from '../../../store/types/element';
import { StageActionsKeys, StageActionsPayload } from '../../../store/types/stageState';
import { getFileUrl } from '@/utils';

@Component({})
export default class OfficeToolbar extends Vue {
  @Getter selectedElement!: RootGettersReturns['selectedElement'];
  @Getter isGuest!: RootGettersReturns['isGuest'];
  @Getter focusState!: RootGettersReturns['focusState'];
  @Getter currentUser!: RootGettersReturns['currentUser'];
  @Getter sharedBoard!: RootGettersReturns['sharedBoard'];
  @Prop(Function) lock!: () => void;
  @Action(ElementActionsKeys.UPDATE_ELEMENT) updateElement!: (payload: ElementActionsPayload['UPDATE_ELEMENT']) => void;
  @Action(StageActionsKeys.SET_FOCUS) focus!: (payload: StageActionsPayload['SET_FOCUS']) => void;

  uuid = '';
  convertedUrl = '';
  url = '';
  data: {
    uuid: string;
    pages: number;
    currentPage: number;
    filename: string;
    convertedRealname: string;
    conversionStatus: number;
  } = {
    uuid: '',
    pages: 0,
    currentPage: 0,
    filename: '',
    convertedRealname: '',
    conversionStatus: 0,
  };

  inputText = this.formatText();

  formatText() {
    if (this.data) {
      return `${this.data.currentPage}/${this.data.pages}`;
    } else {
      return '';
    }
  }

  get fileExtension() {
    if (!this.data?.filename) return '';
    return this.data?.filename.split('.')[this.data.filename.split('.').length - 1] || '';
  }

  canPrev = false;
  canNext = false;

  async mounted() {
    await this.setData();
  }

  @Watch('selectedElement', { deep: true })
  async setData() {
    if (!this.selectedElement) return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.data = { conversionStatus: 1, ...(this.selectedElement.data as any) };
    this.uuid = this.data.uuid;
    this.canPrev = this.data.currentPage > 1;
    this.canNext = this.data.currentPage < this.data.pages;
    this.inputText = this.formatText();
    await this.setOriginalUrl();
    await this.setConvertedUrl();
  }

  async setOriginalUrl() {
    this.url = await getFileUrl(this.data.filename);
  }

  async setConvertedUrl() {
    this.convertedUrl = await getFileUrl(this.data.convertedRealname);
  }

  updatePage(page: number) {
    if (this.selectedElement) {
      this.updateElement({
        ...this.selectedElement,
        data: {
          ...this.selectedElement.data,
          currentPage: page,
          usedBy: this.currentUser?.id,
        },
      });
      this.data.currentPage = page;
      this.canPrev = page > 1;
      this.canNext = page < this.data.pages;
      this.inputText = this.formatText();
    }
  }

  deleteElement() {
    if (!this.selectedElement) return;
    this.updateElement({
      ...this.selectedElement,
      deleted: true,
    });
  }

  focusElement() {
    if (!this.selectedElement) return;
    this.focus({ board_element: this.focusState ? null : this.selectedElement, withPrevState: true });
  }

  get isShared() {
    return (this.selectedElement?.data as { shared: boolean }).shared;
  }

  get isUsed() {
    return !!(this.selectedElement?.data as { usedBy: number | boolean }).usedBy;
  }

  get isLocked() {
    return (
      (this.selectedElement?.data as { usedBy: number | boolean }).usedBy &&
      (this.selectedElement?.data as { usedBy: number }).usedBy !== this.currentUser?.id
    );
  }

  async share() {
    if (!this.selectedElement) return;
    await this.updateElement({
      ...this.selectedElement,
      data: {
        ...this.selectedElement.data,
        shared: !(this.selectedElement.data as { shared: boolean }).shared,
        usedBy: false,
      },
    });
    this.$root.$emit('cancelDouble');
  }

  async unlock() {
    if (!this.selectedElement) return;
    await this.updateElement({
      ...this.selectedElement,
      data: {
        ...this.selectedElement.data,
        usedBy: false,
      },
    });
    this.$root.$emit('cancelDouble');
  }
}
